import * as ActionTypes from '../../actions/CartActions';
import {
  getShippingAddressFields,
  customFieldsNormalizer,
  customFormFields,
} from 'payments/reducers/refine/customFields';

import { objectWithout } from 'config/utils';
const initialShippingState = {
  form: {
    name: '',
    email: '',
    phone: '',
    errors: {},
  },
  isValidated: false,
};

const shipping = (state = initialShippingState, action) => {
  switch (action.type) {
    case ActionTypes.HANDLE_FETCH_CART_SUCCESS:
    case ActionTypes.HANDLE_ADD_TO_CART_SUCCESS:
    case ActionTypes.HANDLE_REMOVE_ITEM_FROM_CART_SUCCESS:
      try {
        const {
          isShippingRequired,
          states,
        } = action.response.cart;
        if (isShippingRequired) {
          return {
            ...state,
            offer: {
              customFields: customFieldsNormalizer(getShippingAddressFields(states)),
            },
            form: {
              ...state.form,
              customFields: customFormFields({
                fields: getShippingAddressFields(states),
              }),
            },
          };
        }
        return state;
      } catch (e) {
        return state;
      }

    case ActionTypes.HANDLE_ON_CHANGE_SHIPPING: {
      const { payload } = action;
      const { isCustomField, ...patch } = payload;
      if (isCustomField) {
        return {
          ...state,
          form: {
            ...state.form,
            customFields: {
              ...state.form.customFields,
              ...patch,
            },
            errors: objectWithout(state.form.errors, Object.keys(patch)[0]),
          },
        };
      }

      return {
        ...state,
        form: {
          ...state.form,
          ...payload,
          errors: objectWithout(state.form.errors, Object.keys(payload)[0]),
        },
      };
    }

    case ActionTypes.HANDLE_CHECKOUT_CART_FAILURE: {
      let { errors } = action;
      // action.errors when frontend generated errors
      // action.errors.errors when backend generated errors
      if (errors.errors) {
        errors = errors.errors;
      }

      return {
        ...state,
        form: {
          ...state.form,
          errors,
        },
      };
    }

    default:
      return state;
  }
};

export default shipping;

export const getShippingDetails = state => state;



// WEBPACK FOOTER //
// ./src/cart/reducers/shipping/index.js